import { useContextSelector } from "use-context-selector";

import { IStore, StoreContext } from "../store-context";
import { INotification, INotifications } from "../types";

export const useNotificationsSelector = (): INotifications =>
  useContextSelector(StoreContext, (store: IStore) => store.userModule.notifications);

export const useDealLastActivitySelector = (dealId: number, amount: number): INotification[] =>
  useContextSelector(StoreContext, (store: IStore) => {
    const dealNotifications = (store.userModule.notifications.list as INotification[])
      .filter((notification) => notification.components.deal_id === dealId)
      .slice(0, amount);
    return dealNotifications;
  });
